exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".main-box[data-v-7bd6a607]{position:absolute;min-width:1260px;width:100%;height:100%;background:#fff}.body-content[data-v-7bd6a607]{position:relative;width:100%;min-height:100%;padding:66px 0;box-sizing:border-box}.body-header[data-v-7bd6a607]{width:100%;position:absolute;top:0;left:0}.body-footer[data-v-7bd6a607]{width:100%;position:absolute;bottom:0;left:0}.content-box[data-v-7bd6a607]{width:100%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-7bd6a607","scoped":true,"hasInlineConfig":false}!./node_modules/postcss-loader/lib!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/main.vue
// module id = 698
// module chunks = 0